module.exports = __webpack_public_path__ + "4e69900d9332899ae477de5b2d56c2a2.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/modelo_planilha_Carga_Geral.xlsx
// module id = ./src/assets/downloads/modelo_planilha_Carga_Geral.xlsx
// module chunks = 1